import { useState, useEffect } from "react";
import { dbGet, dbSet } from "../lib/db";

const PK = "reconectados_plan";

const SECTIONS = [
  {
    id: "alertas",
    emoji: "🚨",
    color: "#E07A5F",
    bg: "#FFF2EE",
    title: "Mis señales de alerta",
    hint: "¿Qué cambios noto en mí antes de estar en riesgo? (pensamientos, emociones, conductas...)",
    placeholder: "Ej: Me aíslo, no duermo bien, empiezo a romantizar el consumo...",
  },
  {
    id: "triggers",
    emoji: "⚡",
    color: "#F4A261",
    bg: "#FFF7F0",
    title: "Mis triggers",
    hint: "¿Qué situaciones, emociones o personas me generan mayor impulso?",
    placeholder: "Ej: El estrés del trabajo, las noches de viernes, el conflicto con...",
  },
  {
    id: "plan",
    emoji: "📋",
    color: "#5B8FCC",
    bg: "#EDF4FF",
    title: "Plan de acción",
    hint: "¿Qué haré, paso a paso, cuando sienta el impulso?",
    placeholder: "Paso 1: Respirar y no actuar de inmediato\nPaso 2: Usar el timer de urge surfing\nPaso 3: Llamar a...",
  },
  {
    id: "contactos",
    emoji: "📞",
    color: "#8B6BAE",
    bg: "#F3EEF9",
    title: "A quién llamo",
    hint: "Personas concretas a las que puedes pedir ayuda. Sé específico.",
    placeholder: "Nombre: — Le diré: 'Estoy teniendo un momento difícil, ¿puedes hablar?'\nNombre: ...",
  },
  {
    id: "porque",
    emoji: "💚",
    color: "#6B9080",
    bg: "#EEF4F1",
    title: "Mi por qué",
    hint: "¿Qué quieres para tu vida? ¿Por qué merece la pena seguir?",
    placeholder: "Lo que me importa de verdad y no quiero perder...",
  },
];

export default function RelapsePlan() {
  const [plan, setPlan]   = useState({});
  const [saved, setSaved] = useState(false);
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    dbGet(PK, {}).then(data => setPlan(data && typeof data === "object" ? data : {}));
  }, []);

  const update = (id, val) => {
    setPlan(p => ({ ...p, [id]: val }));
    setDirty(true);
    setSaved(false);
  };

  const save = async () => {
    await dbSet(PK, plan);
    setSaved(true);
    setDirty(false);
    setTimeout(() => setSaved(false), 2500);
  };

  const filled = SECTIONS.filter(s => plan[s.id]?.trim()).length;

  return (
    <div className="space-y-4 animate-fade-in-up">

      {/* Intro */}
      <div className="bg-[#EEF4F1] rounded-2xl p-4">
        <p className="text-sm font-semibold text-[#6B9080] mb-1" style={{ fontFamily: "Manrope" }}>
          Plan de prevención de recaída
        </p>
        <p className="text-xs text-[#2C4238] leading-relaxed">
          Tu plan, en tus propias palabras. En un momento de crisis, abre esta pantalla y sigue tu propio guión.
          Cuanto más específico, más útil.
        </p>
        {filled > 0 && (
          <p className="text-xs text-[#6B9080] mt-2 font-semibold">
            {filled}/{SECTIONS.length} secciones completadas
          </p>
        )}
      </div>

      {/* Sections */}
      {SECTIONS.map(s => (
        <div key={s.id} className="bg-white rounded-2xl border border-[#E4EBE6] overflow-hidden">
          <div className="flex items-start gap-3 px-4 pt-4 pb-2">
            <div
              className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0 text-base"
              style={{ backgroundColor: s.bg }}
            >
              {s.emoji}
            </div>
            <div className="flex-1">
              <p className="text-sm font-semibold text-[#1E2F23]" style={{ fontFamily: "Manrope" }}>
                {s.title}
              </p>
              <p className="text-xs text-[#4A6E5C] mt-0.5 leading-relaxed">{s.hint}</p>
            </div>
          </div>
          <div className="px-4 pb-4">
            <textarea
              value={plan[s.id] ?? ""}
              onChange={e => update(s.id, e.target.value)}
              placeholder={s.placeholder}
              rows={4}
              className="w-full p-3 rounded-xl border border-[#E4EBE6] bg-[#F7F9F7] text-sm text-[#1E2F23] resize-none focus:outline-none focus:border-[#6B9080] leading-relaxed"
              style={{ minHeight: 96 }}
            />
          </div>
        </div>
      ))}

      {/* Save button */}
      <button
        onClick={save}
        disabled={!dirty && !saved}
        className={`w-full py-4 rounded-2xl font-semibold text-base transition-all active:scale-95 ${
          saved
            ? "bg-[#84A98C] text-white"
            : dirty
            ? "bg-[#6B9080] text-white"
            : "bg-[#F7F9F7] text-[#4A6E5C] border border-[#E4EBE6]"
        }`}
      >
        {saved ? "✓ Plan guardado" : "Guardar mi plan"}
      </button>

      <p className="text-xs text-[#4A6E5C] text-center pb-4 leading-relaxed">
        Solo visible en este dispositivo · Basado en prevención de recaída cognitivo-conductual (Marlatt &amp; Gordon, 1985)
      </p>
    </div>
  );
}
